import React from 'react';

export function FinancialAdvisorIcon() {
  return (
    <svg
      width="24"
      height="28"
      viewBox="0 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 21">
        <g id="Group 2331">
          <path
            id="Vector"
            d="M4.0202 6.71003L2.2002 5.66003"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_2"
            d="M7.14018 4.11L5.93018 2.38"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_3"
            d="M10.7501 3.07L10.3901 1"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_4"
            d="M20.8999 10.47H23.0099"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_5"
            d="M20.1602 7.42003L22.0702 6.53003"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_6"
            d="M17.5698 4.85999L18.9198 3.23999"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_7"
            d="M14.2803 3.45003L14.8203 1.41003"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          id="head"
          d="M19.28 12.39V13.22C19.28 13.22 19.26 13.31 19.26 13.36C19.23 13.64 19.21 13.92 19.17 14.2C19 15.44 18.62 16.62 18.14 17.77C17.67 18.91 16.56 20.79 16.38 21.22C15.94 22.31 16.12 23.54 16.29 24.7C16.38 25.36 16.56 26 16.91 26.58C17.03 26.77 16.93 26.99 16.71 27C16.22 27.02 15.75 26.99 15.26 27C14.51 27.02 13.76 26.98 13.02 27C13.02 27 10.59 26.98 10.1 26.98C9.17 26.98 8.28 27 8.28 27V26.53C8.28 26.53 8.38 24.76 8.21 23.68C7.92 23.78 7.65 23.87 7.38 23.96C6.55 24.22 5.71 24.43 4.83 24.5C4.36 24.54 3.89 24.53 3.43 24.39C2.69 24.16 2.31 23.58 2.41 22.81C2.46 22.43 2.54 22.06 2.59 21.68C2.67 21 2.73 20.32 2.67 19.64C2.65 19.45 2.6 19.27 2.57 19.09C2.55 19 2.49 18.97 2.4 18.95C2.2 18.93 2 18.9 1.81 18.84C1.42 18.74 1.11 18.54 1 18.12V17.87C1.09 17.46 1.38 17.17 1.62 16.85C2.08 16.23 2.55 15.6 2.92 14.92C3.57 13.83 3.52 10.76 4.26 9.21001C4.77 8.14001 5.47 7.23001 6.43 6.53001C6.64 6.37001 7.71 5.64001 9.27 5.39001C13.85 4.72001 18.13 5.69001 19.23 11.78C19.26 11.98 19.28 12.19 19.3 12.39H19.28Z"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="coin"
          d="M11.4902 7.21997C14.5057 7.21997 16.9502 9.66447 16.9502 12.6799C16.9502 15.6954 14.5057 18.1399 11.4902 18.1399C8.47478 18.1399 6.03027 15.6954 6.03027 12.6799C6.03029 9.66449 8.47479 7.21999 11.4902 7.21997ZM11.4902 8.21997C9.02708 8.21999 7.03029 10.2168 7.03027 12.6799C7.03027 15.1431 9.02706 17.1399 11.4902 17.1399C13.9534 17.1399 15.9502 15.1431 15.9502 12.6799C15.9502 10.2168 13.9534 8.21997 11.4902 8.21997ZM11.501 9.47974C11.777 9.48025 12.0004 9.70468 12 9.98071L11.999 10.2854C12.6525 10.4605 13.2 10.9769 13.2002 11.6897C13.2001 11.9658 12.9763 12.1897 12.7002 12.1897C12.4241 12.1897 12.2003 11.9657 12.2002 11.6897C12.2 11.6002 12.1343 11.4684 11.9971 11.3665L11.9951 12.2366C12.6443 12.4095 13.2001 12.9106 13.2002 13.6399C13.2001 14.3672 12.6444 14.8769 11.9902 15.052V15.3704C11.9897 15.6465 11.7654 15.8699 11.4893 15.8694C11.2132 15.8688 10.9897 15.6445 10.9902 15.3684V15.053C10.3391 14.881 9.78035 14.3806 9.78027 13.6497C9.78053 13.3737 10.0043 13.1497 10.2803 13.1497C10.5563 13.1497 10.78 13.3737 10.7803 13.6497C10.7803 13.7424 10.8467 13.8766 10.9922 13.9788L10.9941 13.1038C10.3398 12.9304 9.78051 12.4229 9.78027 11.7004C9.78027 10.9745 10.3441 10.4654 10.999 10.2883L11 9.97876C11.0007 9.70283 11.225 9.47935 11.501 9.47974ZM11.9922 13.9709C12.1333 13.8677 12.2001 13.7343 12.2002 13.6399C12.2001 13.5482 12.1351 13.4162 11.9932 13.3147L11.9922 13.9709ZM10.9971 11.3694C10.8486 11.4748 10.7803 11.6112 10.7803 11.7004C10.7805 11.7896 10.8489 11.9244 10.9961 12.0276L10.9971 11.3694Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
